module.exports = __webpack_public_path__ + "static/media/florent.a7491116.jpg";